(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wfi-anubar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('.cab');
    bars.forEach((bar) => {
      const closeBtn = bar.querySelector('[data-cab-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          bar.style.display = 'none';
          try { sessionStorage.setItem(bar.id + ':dismissed', '1'); } catch (e) {}
        });
        try {
          if (sessionStorage.getItem(bar.id + ':dismissed') === '1') {
            bar.style.display = 'none';
          }
        } catch (e) {}
      }

      const timer = bar.querySelector('[data-cab-timer]');
      if (!timer) return;

      const endRaw = timer.getAttribute('data-end');
      const expiredText = timer.getAttribute('data-expired-text') || '';
      const endDate = endRaw ? new Date(endRaw.replace(' ', 'T')) : null;
      if (!endDate || isNaN(endDate.getTime())) return;

      const boxes = {
        days: timer.querySelector('[data-unit="days"]'),
        hours: timer.querySelector('[data-unit="hours"]'),
        minutes: timer.querySelector('[data-unit="minutes"]'),
        seconds: timer.querySelector('[data-unit="seconds"]'),
      };

      const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

      const tick = () => {
        const diff = endDate.getTime() - Date.now();
        if (diff <= 0) {
          if (expiredText) {
            timer.innerHTML = '<span class="cab__timer-label" style="font-size:1em">' + expiredText + '</span>';
          } else {
            Object.values(boxes).forEach((b) => { if (b) b.textContent = '00'; });
          }
          clearInterval(id);
          return;
        }
        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (boxes.days) boxes.days.textContent = pad(days);
        if (boxes.hours) boxes.hours.textContent = pad(hours);
        if (boxes.minutes) boxes.minutes.textContent = pad(minutes);
        if (boxes.seconds) boxes.seconds.textContent = pad(seconds);
      };

      tick();
      const id = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
